define('core/factory/LazyLoadImageRefreshFactory',[
    'angular'
], function(angular) {
    'use strict';

    angular.module('dnaApp').factory('LazyLoadImageRefreshInterceptor',['$rootScope', '$timeout',
        function LazyLoadImageRefreshInterceptor($rootScope, $timeout) {
            var existingTimeout;

            // set up a timeout to trigger lazy load image refresh after 500ms
            function lazyImageRefreshTimeout() {
                return $timeout(function() {
                    $rootScope.$broadcast('lazyImg:refresh');
                }, 500);
            }

            var response = function(response) {
                // if timeout is existing, cancel it to reduce the number of broadcasts
                if (existingTimeout) {
                    $timeout.cancel(existingTimeout);
                }

                existingTimeout = lazyImageRefreshTimeout();

                return response;
            };

            var triggerLazyImgRefresh = function() {
                lazyImageRefreshTimeout();
            };

            return {
                response: response,
                triggerLazyImgRefresh: triggerLazyImgRefresh
            };
        }
    ]);
});

